<template>
  <div>
		<section class="contact py-5" id="contact">
            <div class="container py-lg-5">
                <p class="paragraph">Entre em contacto comigo</p>
                <h3 class="heading mb-sm-5 mb-4">Contacto</h3>
                <div class="contact-form">
                    <div class="row">
                        <div class="col-lg-8">
                            <form name="contactform" id="contactform" method="post" action="#" onsubmit="return(validate());" novalidate="novalidate">
                                <div class="row">
                                    <div class="form-group col-md-6 ">
                                    <label>Nome</label>
                                    <input type="text" class="form-control" id="name" placeholder="Introduza o seu nome" name="name">
                                    </div>
                                    <div class="form-group col-md-6">
                                    <label>Email</label>
                                    <input type="email" class="form-control" id="email" placeholder="Introduza o seu Email" name="email">
                                    </div>
                                    <div class="form-group col-md-6">
                                    <label>Telefone.</label>
                                    <input type="text" class="form-control" id="phone" placeholder="Introduza o seu telefone." name="phone">
                                    </div>
                                    <div class="form-group col-md-6">
                                    <label>Assunto</label>
                                    <input type="text" class="form-control" id="subject" placeholder="Assunto" name="phone">
                                    </div>
                                    <div class="form-group col-12">
                                    <label>Messagem</label>
                                    <textarea name="issues" class="form-control" id="iq" placeholder="Escreva a tua mensagem aqui"></textarea>
                                    </div>				
                                    <button type="submit" class="btn btn-default">Enviar </button>
                                </div>
                            </form>
                        </div>
                        <section class="w3layouts-map col-lg-4 mt-lg-0 mt-5">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.9503398796587!2d-73.9940307!3d40.719109700000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a27e2f24131%3A0x64ffc98d24069f02!2sCANADA!5e0!3m2!1sen!2sin!4v1441710758555" allowfullscreen=""></iframe>
                        </section>
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Contact.vue